define('src/file-upload-model',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api'
], function(_, Backbone, U, API) {

    var methodMap = Backbone.Model.methodMap,
        multipartMethod = ['create', 'update', 'patch'];

    var FileUploadModel = Backbone.Epoxy.Model.extend({

        initialize: function(options) {
            if(!options) {
                return;
            }

            if(options.files) {
                this.files = options.files;
            }
            if(options.urlRoot) {
                this.urlRoot = API.url(options.urlRoot);
            }
        },

        isMultipartMethod: function(method) {
            return multipartMethod.indexOf(method) > -1;
        },

        sync: function(method, model, options) {

            // Post data as FormData object on create to allow file upload
            if (this.isMultipartMethod(method)) {

                var files = this.getFiles(options);

                if (files.length) {

                    var formData = new FormData();
                    formData.append('_method', methodMap[method]);
                    formData.append('_json', JSON.stringify(_.omit(options.attrs, files)));

                    var fileList = [];

                    // append all files.
                    _.each(files, function(field) {
                        var fieldData = this.get(field);

                        if(typeof(fieldData) == "string") {
                            return;
                        }

                        // The field in attribute can be a lone file or a collection of files
                        if(fieldData && (fieldData.name || fieldData.filename)) {
                            fileList.push({
                                fieldName: field,
                                file: fieldData
                            });
                        }
                        else if(fieldData && fieldData.length > 0){
                            fileList = fieldData.map(function(model) {
                                return {
                                    fieldName: field,
                                    file: model.get(field)
                                }
                            });
                        }
                    }, this);

                    _.each(fileList, function(file) {
                        if(!isFile(file.file)) {
                            return;
                        }

                        // Get the filename from either filename or name property
                        var fileName = file.file.filename || file.file.name;

                        // Create a new File object with explicit filename to ensure it's preserved
                        var fileToUpload = file.file;
                        if (!fileToUpload.name || fileToUpload.name === '') {
                            // If the file doesn't have a name property, create a new File object
                            fileToUpload = new File([file.file], fileName, { type: file.file.type });
                        }

                        // Always provide filename as third parameter
                        formData.append(file.fieldName + "[]", fileToUpload, fileName);
                    })

                    // Set processData and contentType to false so data is sent as FormData
                    _.defaults(options || (options = {}), {
                        data: formData,
                        processData: false,
                        contentType: false
                    });

                    // reset the method to 'create' (so a POST) as this is the only
                    // accepted method from the php API at the moment.
                    method = 'create';
                }
            }

            return FileUploadModel.__super__.sync.call(this, method, model, options);
        },

        getFiles: function() {
            // This is an array of the model's FIELDS that contain an attachment
            // e.g ["photo", "attachments"] means that `model.get("photo")` returns the file or an array of files
            var files = _.result(this, 'files', []);

            // Multiple fields can have a FILE
            // Each specified field can be either a FILE or an array with FILE elements
            var fieldsWithFiles = []

            files.forEach(function(field) {
                var fieldFiles = this.get(field);

                // The property is an array with many FILE elements
                if(fieldFiles && Array.isArray(fieldFiles)) {

                    // Add the field to the returning array if every element in the array is a file
                    var nonFileElementsExist = fieldFiles.some(function(fieldFile) {
                        // Properties are different for messages and notes
                        // attachments for messages, attachment for notes
                        return !isFile(fieldFile.get("attachments") || fieldFile.get("attachment"));
                    });

                    if(!nonFileElementsExist) {
                        fieldsWithFiles.push(field)
                    }
                // The property is a single FILE
                } else if(isFile(fieldFiles)) {
                    fieldsWithFiles.push(field)
                }
            }.bind(this));

            return fieldsWithFiles;
        },
    });

    function isFile(data) {
        return data instanceof Blob || data instanceof File;
    }

    return FileUploadModel;
});

